import React from 'react';
import PropTypes from 'prop-types';
import {
  OrderView,
  ShipmentStatus,
  orderStatus,
} from '../../../../orders/order';
import { FormattedDate } from 'react-intl';
import { ProductConfiguration } from '../../../../products/productConfiguration';
import OrderShipmentProduct from './OrderShipmentProduct';
import ShipViaComponent from './ShipViaComponent';
import ShipmentBadgeComponent from './ShipmentBadgeComponent';
import { withRouter } from 'react-router-dom';
import { isAmiUserAuthorizedToManageTasks } from '../../../../authorization/amiPermissions';
import { GoogleMapsLink } from '@ami/react/core';

class OrderShipmentComponent extends React.PureComponent {
  static propTypes = {
    order: PropTypes.instanceOf(OrderView).isRequired,
    shipment: PropTypes.any.isRequired,
    onConfirmDateButtonClicked: PropTypes.func.isRequired,
    onMarkShippedButtonClicked: PropTypes.func.isRequired,
    onUnshipButtonClicked: PropTypes.func.isRequired,
    canChangeStatus: PropTypes.bool.isRequired,
    productConfiguration: PropTypes.instanceOf(ProductConfiguration).isRequired,
    loadOrder: PropTypes.func.isRequired,
    history: PropTypes.object,
  };

  newAmiTask = (id) => {
    this.props.history.push(
      `/ami-tasks/new/OrderLine/${this.props.order.id}/${id}`
    );
  };

  render() {
    const {
      order,
      shipment,
      onConfirmDateButtonClicked,
      onMarkShippedButtonClicked,
      onUnshipButtonClicked,
      canChangeStatus,
      loadOrder,
    } = this.props;
    const lineItems = order.lineItems.filter(
      (x) => x.shipmentId === shipment.id
    );
    const statusIsPending = order.status === orderStatus.pending.id;

    return (
      <div className="card order-shipment">
        <div className="card-header">
          <div className="row">
            <div className="col-6 col-sm-5">
              <div className="label">Completion Date</div>
              <h5 className="mb-0">
                <FormattedDate
                  value={shipment.shipmentDate}
                  year="numeric"
                  month="long"
                  day="2-digit"
                  timeZone="utc"
                />
              </h5>
              <ShipmentBadgeComponent shipment={shipment} />
              <div className="row">
              <label className="col-sm-2">Ship To</label>
              <div className="col-sm-10">
                {shipment.customLocation && (
                  <GoogleMapsLink location={shipment.customLocation} />
                )}
                {!shipment.customLocation && order.dealerInformation && (
                  <div className='row'>
                    <div className='col-12'>{ `Dealer Branch (${order.dealerInformation.dealerBranchName})`}</div>
                    <div className='col-12'>{order.dealerInformation.dealerBranchAddress}</div>
                  </div>
                )}
              </div>
            </div>
            { shipment.customInstruction &&
              (<div className="row">
              <div className="col-sm-10 text-break-line">
                 <span>{shipment.customInstruction}</span>
              </div>
              </div>
            )}
             </div>
            <div className="col-6 col-sm-3">
              <ShipViaComponent shipment={shipment} />
            </div>
            <div className="col-12 col-sm-4 text-end">
              {canChangeStatus && (
                <div className="btn-group" role="group">
                  {shipment.status === ShipmentStatus.Scheduled && (
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={onConfirmDateButtonClicked}
                    >
                      Confirm Completion Date
                    </button>
                  )}
                  {(shipment.status === ShipmentStatus.Scheduled ||
                    shipment.status === ShipmentStatus.Confirmed) && (
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={onMarkShippedButtonClicked}
                    >
                      Mark as Shipped
                    </button>
                  )}
                  {shipment.status === ShipmentStatus.Shipped && (
                    <button
                      type="button"
                      className="btn btn-outline-primary"
                      onClick={onUnshipButtonClicked}
                    >
                      Unship
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="card-body line-items">
          {lineItems.map((lineItem, i) => (
            <div key={i} className="shipment-line-item">
              <OrderShipmentProduct
                order={order}
                lineItem={lineItem}
                productConfiguration={this.props.productConfiguration}
                loadOrder={loadOrder}
                onNewTask={(id) => this.newAmiTask(id)}
                enabledAddCustomerApproval={statusIsPending}
                enabledNewTask={
                  statusIsPending && isAmiUserAuthorizedToManageTasks()
                }
              />
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default withRouter(OrderShipmentComponent);
